import React from 'react';

interface Props {
  children: React.ReactNode;
  onRetry: () => void;
}

interface State {
  hasError: boolean;
}

class GraphErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('GraphErrorBoundary caught:', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    this.props.onRetry();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 12 }}>
          <p style={{ margin: 0 }}>Something went wrong rendering the graph.</p>
          <p style={{ margin: 0, fontSize: 13, color: '#666' }}>
            If this keeps happening, try the <strong>Network</strong> or <strong>Capability</strong> view.
          </p>
          <button onClick={this.handleRetry} style={{ padding: '8px 16px', cursor: 'pointer' }}>
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default GraphErrorBoundary;
